export default "__VITE_ASSET__CRHWOXVe__"